import React, { FC } from 'react';
import { IIconProps } from 'app/components/svgs/Icon';

/**
 * Taken from icomoons free vector graphic set.
 */
const UserSilhouette: FC<IIconProps> = ({
  size = '100%',
  color = '#000000',
  width = size,
  height = size,
  ...props
}) => (
  <svg width={width} height={height} viewBox="0 0 16 16" preserveAspectRatio="xMidYMid meet" {...props}>
    <path
      fill={color}
      d="M9 11.041v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485
          0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095
          2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h14c0-2.015-2.608-3.682-6-3.959z"
    />
  </svg>
);

export default UserSilhouette;
